import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesAreas = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
    message: null,
  },
  mutations: {
    readAreas(state) {
      state.data = null
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    deleteArea(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readAreasSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    deleteAreasSuccess(state, AreaId) {
      state.data = state.data.filter(function(value){
        return value.id != AreaId
      })
      state.loading = false
      state.loadError = false
      state.message = i18n.t('messages.deleted', { value: i18n.t('models.area.modelName') })
    },
    apiFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors.response.data.errors[0].detail
    }
  },
  actions: {
    readAreas({ commit }, company_uuid) {
      commit('readAreas')
      axios
        .get('/api/companies/' + company_uuid + '/areas.json')
        .then(res => {
          commit('readAreasSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    deleteArea({ commit }, { company_uuid, area_id }) {
      commit('deleteArea')
      axios
        .delete('/api/companies/' + company_uuid + '/areas/' + area_id + '.json')
        .then(() => {
          commit('deleteAreasSuccess', area_id)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
  }
}
